import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=63ed801c&scoped=true&"
import script from "./Form1.vue?vue&type=script&lang=js&"
export * from "./Form1.vue?vue&type=script&lang=js&"
import style0 from "./Form1.vue?vue&type=style&index=0&id=63ed801c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed801c",
  null
  
)

export default component.exports